import { motion } from "framer-motion";
import { FadeUp } from "@/components/AnimatedSection";
import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const areas = [
  { name: "Washington DC", sub: "All districts", emoji: "🏛️" },
  { name: "Northern Virginia", sub: "Vienna, Tysons, McLean, Arlington, Fairfax, Reston", emoji: "🌳" },
  { name: "Maryland", sub: "Bethesda, Silver Spring, Rockville, Potomac", emoji: "🏠" },
];

const ServiceAreaMap = () => (
  <section className="section-padding bg-background relative overflow-hidden">
    <div className="absolute inset-0 mesh-gradient" />
    <div className="orb-glow orb-gold w-[400px] h-[400px] top-0 left-0 opacity-8 orb-pulse" />
    <div className="container-luxury relative">
      <FadeUp className="text-center mb-14">
        <span className="badge-shimmer mb-4 inline-flex">Where We Serve</span>
        <h2 className="font-display text-3xl md:text-5xl font-bold">
          Service <span className="gold-gradient-text">Area</span>
        </h2>
        <p className="text-muted-foreground mt-4 max-w-lg mx-auto text-sm leading-relaxed">
          We bring premium mobile detailing directly to your driveway across the entire DMV area.
        </p>
      </FadeUp>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <FadeUp>
          <div className="rounded-2xl overflow-hidden border border-border/50 gold-glow h-[420px] img-cinematic">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d198704.54937080306!2d-77.1545!3d38.8942!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b82921a2cf17%3A0x482a3f7c10cf8c4!2sWashington%2C%20DC!5e0!3m2!1sen!2sus!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0, filter: "invert(90%) hue-rotate(180deg) brightness(1.1) contrast(0.9)" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Metroshine service area map"
            />
          </div>
        </FadeUp>

        <FadeUp>
          <div className="space-y-4">
            {areas.map((area, i) => (
              <motion.div
                key={i}
                className="luxury-card-elite flex items-start gap-4 rounded-xl !p-5"
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.15 * i }}
                whileHover={{ y: -3, x: 4, transition: { duration: 0.3 } }}
              >
                <div className="w-12 h-12 rounded-xl gold-gradient-bg flex items-center justify-center flex-shrink-0 text-lg shadow-lg shadow-primary/15">
                  {area.emoji}
                </div>
                <div>
                  <h3 className="font-display font-semibold text-foreground mb-1">{area.name}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{area.sub}</p>
                </div>
              </motion.div>
            ))}
            <p className="text-muted-foreground/60 text-xs mt-4 tracking-wide">
              Don't see your area? Contact us — we may still be able to arrive at your location.
            </p>
            <motion.div whileHover={{ scale: 1.04, y: -2 }} whileTap={{ scale: 0.98 }} className="pt-2">
              <Link
                to="/book"
                className="inline-flex items-center gap-2 gold-gradient-bg text-primary-foreground px-6 py-3 text-sm font-semibold tracking-wide rounded-xl btn-luxury btn-shine btn-magnetic"
              >
                Check Availability <ArrowRight size={14} />
              </Link>
            </motion.div>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);

export default ServiceAreaMap;
